export enum SearchOperatorsEnum {
  EQUALS = '==',
  GREATER_THAN_OR_EQUAL = 'gte',
  LESS_THAN_OR_EQUAL = 'lte',
  GREATER_THAN = 'gt',
  LESS_THAN = 'lt',
  IN = 'in',
  LIKE = 'like',
  FUZZY = 'fuzzy',
  DIFFERENT = '!=',
  NUMERIC_EQUAL = 'eq',
}
